import store from '@/store'

import { lazyLoad } from './index'

export default {
  path: '/customartist',
  component: lazyLoad('CustomArtist/layout'),
  redirect: 'customartist/upload',
  meta: { requiresAuth: true },
  beforeEnter: (to, from, next) => {
    if (store.getters.isCustomArtist) { next() } else { next('/') }
  },
  children: [
    { path: 'upload',
      component: lazyLoad('CustomArtist/Upload'),
    },
    { path: 'artworks',
      component: lazyLoad('CustomArtist/Artworks'),
    },
    { path: 'orders',
      component: lazyLoad('CustomArtist/Orders'),
    },
  ]
}
